@if(resellerSettingsContext) {
<div class="banner">
	<div
		#carousel
    id="banner"
		class="carousel w-100"
		[ngClass]="[resellerSettingsContext.banner.transition]"
		[attr.data-bs-config]="carouselConfiguration"
		[attr.data-bs-ride]="resellerSettingsContext.banner.configuration.ride">
		<!-- Bottom indicators -->
		@if (resellerSettingsContext.banner.bottomIndicatorsVisible) {
		<div class="carousel-indicators">
			@for (contentItem of resellerSettingsContext.banner.data; track $index) {
			<button type="button" data-bs-target="#banner" [attr.data-bs-slide-to]="$index" [ngClass]="{ active: contentItem.active }" aria-current="true" aria-label="slide"></button>
			}
		</div>
		}

		<!-- /Bottom indicators -->

		<!-- Main images container-->
		<div class="carousel-inner" [style.height]="resellerSettingsContext.banner.height">
			@for (contentItem of resellerSettingsContext.banner.data; track $index) {
			<div [ngClass]="{ 'carousel-item': contentItem.id, active: contentItem.active }">
				<img [src]="contentItem.image" class="d-block w-100 img-fluid" alt="header content" [style.min-height]="resellerSettingsContext.banner.height" [style.max-height]="resellerSettingsContext.banner.height" />

				@if (resellerSettingsContext.banner.description.visible) {
				<div class="carousel-caption d-md-block pt-0">
					<span class="title">{{ 'LANDING.' + (resellerSettingsContext.reseller.name | uppercase) + '.' + contentItem.title | translate }}</span>
					<p>{{ 'LANDING.' + (resellerSettingsContext.reseller.name | uppercase) + '.' + contentItem.text | translate }}</p>

					<div>
						@for (button of resellerSettingsContext.banner.buttons; track $index) {
						<button mat-flat-button [color]="button.color" class="me-1" (click)="navigateToPage(button.routerLink)">
							{{ 'LANDING.' + (resellerSettingsContext.reseller.name | uppercase) + '.' + button.title | translate }}
						</button>
						}
					</div>
				</div>
				}
			</div>
			}
		</div>
		<!-- /Main images container-->

		<!-- Navigation buttons -->
		@if (resellerSettingsContext.banner.navigationButtonsVisible) {
		<button class="carousel-control-prev" type="button" data-bs-slide="prev" data-bs-target="#banner">
			<span class="carousel-control-prev-icon" aria-hidden="true"></span>
			<span class="visually-hidden">Previous</span>
		</button>
		<button class="carousel-control-next" type="button" data-bs-slide="next" data-bs-target="#banner">
			<span class="carousel-control-next-icon" aria-hidden="true"></span>
			<span class="visually-hidden">Next</span>
		</button>
		}

		<!-- /Navigation buttons -->
	</div>
</div>
}
